// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "chartkick/chart.js"

// Import React
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from '../App'

// Rails.start()
// Turbolinks.start() // DISABLED - conflicts with React
ActiveStorage.start()

// Mount React app - simple, no Turbolinks
document.addEventListener('DOMContentLoaded', () => {
    const rootElement = document.getElementById('react-root');
    if (rootElement) {
        const root = createRoot(rootElement);
        root.render(<App />);
    }
});
